import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'

import { Image } from '../utils/lazyImage'

import Styles from '../../styles/components/portfolio.module.scss'
const {
  item,
  image: imageClass,
  // title: titleClass,
  background: backgroundClass,
} = Styles

class PortoflioItem extends React.PureComponent {
  render() {
    const { image, title, permalink, size } = this.props

    return (
      <Link to={permalink} className={item}>
        <Image
          style={{ position: 'absolute' }}
          sizes={image}
          alt={title}
          className={imageClass}
        />
        <div className={backgroundClass} />
        <div className={Styles.titleWrapper}>
          <div className={Styles.title}>{title}</div>
        </div>
      </Link>
    )
  }
}

PortoflioItem.propTypes = {
  title: PropTypes.any,
  image: PropTypes.any,
  permalink: PropTypes.string.isRequired,
}

PortoflioItem.defaultProps = {
  title: 'nazwa firmy tytuł projektu trzy linijki',
  permalink: '/#',
}

export default PortoflioItem



// WEBPACK FOOTER //
// ./src/components/portfolio/item.js